<template>
    <div>
        <modaltutorial v-model="dialog" :propAdd='paramProp' :val='val' />
        <modalconfirm ref="modalconfirmTutorial" @action="deleteData" />
        <div class="d-flex justify-space-between">
            <div class="text-h5">E-Learning</div>
        </div>
        <v-card class="mt-3 mb-3" outlined>
            <v-list color="deep-purple lighten-5" dark class="pa-3">
                <v-list-item dense class="px-1">
                    <v-btn light depressed class="primary" @click="() => { dialog = true; paramProp = 'tambah'; val = {}; }">
                        <v-icon>mdi-plus-circle</v-icon>
                        <div class="pl-2 text-capitalize">Tambah E-Learning</div>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
                        <v-icon>mdi-filter</v-icon>
                        <div class="pl-2 text-capitalize">Filter</div>
                    </v-btn>
                </v-list-item>
            </v-list>
        </v-card>
        <v-slide-y-transition>
            <v-card outlined class="mb-3" v-if="dropfilter">
                <filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
            </v-card>
        </v-slide-y-transition>
        <v-card outlined>
            <v-data-table loading disable-pagination :headers="headers" :items="tutorialResults" :search="search" hide-default-footer
                :options.sync="option" :server-items-length="tutorialPagination.total_data">
                <template v-slot:item.tutorial_id="{ item }">
                    <div v-if="isUrl(item.tutorial_thumbnail)" class="embed-responsive embed-responsive-16by9 pl-2 my-2">
                        <v-avatar tile color="grey" size="90" width="120%">
                            <img class="avatar" :src="item.tutorial_thumbnail">
                        </v-avatar>
                    </div>
                    <div v-else class="embed-responsive embed-responsive-16by9 pl-2 my-2">
                        <v-avatar tile size="90" width="100%">
                            <img class="avatar" :src="item.tutorial_thumbnail">
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.tutorial_title="{ item }">
                    <div class="pl-2 my-auto">{{ item.tutorial_title }}</div>
                </template>
                <template v-slot:item.tutorial_category_name="{ item }">
                    <v-chip :color="item.tutorial_category_color"
                        :text-color="fontColorbyBG(item.tutorial_category_color) ? '#FFFFFF' : '#000000'">{{ item.tutorial_category_name
                        }}</v-chip>
                </template>
                <template v-slot:item.tutorial_link="{ item }">
                    <div class="pl-2 my-auto"><a :href="item.tutorial_link">{{ item.tutorial_link }}</a></div>
                </template>
                <template v-slot:item.tutorial_caption="{ item }">
                    <div class="pl-2 my-auto">{{ truncate(item.tutorial_caption) }}</div>
                </template>
                <template v-slot:item.tutorial_status="{ item }">
                    <v-switch v-model="item.tutorial_status" @change="editStatus(item)"></v-switch>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="ubah(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
                                <v-icon dark>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click.stop="hapus(item.tutorial_id, item.tutorial_title)" class="" fab dark x-small depressed color="pink"
                                v-bind="attrs" v-on="on">
                                <v-icon dark>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Hapus</span>
                    </v-tooltip>
                </template>
                <template v-slot:progress>
                    <div> </div>
                </template>
                <template v-slot:loading>
                    <div class="py-3" v-if="!tutorialPagination">
                        <loading-data></loading-data>
                    </div>
                    <div class="py-3" v-else>
                        <not-found></not-found>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-5">
            <v-row v-if="tutorialPagination">
                <v-col cols="12" md="11" class="py-0 d-flex justify-end">
                    <v-pagination v-model="page" :length="tutorialPagination.total_page" @input="changePage" total-visible="7" circle
                        class="d-flex justify-end"></v-pagination>
                </v-col>
                <v-col cols="12" md="1" class="py-0 pl-0">
                    <v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" @input="changeLimit"
                        label="Item"></v-autocomplete>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import modaltutorial from '@/views/MLwarehouse/tutorial/ModalTutorial'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
    inject: ['theme'],
    components: {
        modaltutorial
    },
    data() {
        return {
            page: 1,
            limit: "10",
            listLimit: ['5', '10', '20', '50', '100'],
            propDelete: '',
            paramProp: '',
            paramDelid: '',
            paramDelName: '',
            val: {},
            edit: 'edit',
            dialog: false,
            dialogConfirm: false,
            dropfilter: false,
            search: '',
            headers: [
                { text: 'Preview', align: 'center', sortable: false, value: 'tutorial_id' },
                { text: 'Judul E-Learning', align: 'start', sortable: true, value: 'tutorial_title', width: '200px' },
                { text: 'Kategori', value: 'tutorial_category_name', sortable: true },
                { text: 'Link E-Learning', value: 'tutorial_link', sortable: false, width: '100px' },
                { text: 'Caption', value: 'tutorial_caption', sortable: false, },
                { text: 'Status', value: 'tutorial_status', sortable: false, },
                { text: 'Aksi', value: 'action', sortable: false, },
            ],
            filterData: [{
                type: 'text',
                label: 'Judul E-Learning',
                filter: {
                    value: '',
                    comparison: 'like',
                    type: 'string',
                    field: 'tutorial_title'
                }
            }, {
                type: 'selection',
                label: 'Kategori',
                itemValue: 'tutorial_category_slug_name',
                itemText: 'tutorial_category_name',
                item: [],
                filter: {
                    value: '',
                    comparison: '=',
                    type: 'string',
                    field: 'tutorial_category_slug_name'
                }
            }],
            params: [],
            paramStatus: {
                id: '',
                status: ''
            }
        }
    },
    props: {
        desserts: Array,
    },
    computed: {
        ...mapState('tutorial', ['tutorialResults', 'responSukses', 'tutorialPagination', 'konfirmResponse']),
    },
    methods: {
        ...mapActions('tutorial', ['getTutorial', 'statusTutorial', 'deleteTutorial', 'getTutorialCategoryOption']),
        ...mapMutations('tutorial', ['clearDataTutorial']),
        ...mapMutations(['setOverlay', 'setFilter']),

        getData() {
            this.getTutorial(this.queryString({ limit: this.limit, page: this.page, params: this.params, sort: this.sortBy, dir: this.sortDir }))
        },
        editStatus(stat) {
            this.paramStatus.id = stat.tutorial_id
            if (stat.tutorial_status == false) {
                this.paramStatus.status = '0'
            } else {
                this.paramStatus.status = '1'
            }
            this.statusTutorial(this.paramStatus).then(() => {
                this.getData()
                this.paramStatus.id = ''
                this.paramStatus.status = ''
            })
        },
        hapus(id, name) {
            this.propDelete = id
            let msg = `Anda yakin ingin menghapus ${name} ?`
            this.$refs.modalconfirmTutorial.setMessage(msg)
            this.$refs.modalconfirmTutorial.showConfirm()
        },
        async deleteData() {
            await this.setOverlay(true)
            await this.$refs.modalconfirmTutorial.hideConfirm()
            await this.deleteTutorial(this.propDelete).then(() => {
                if (this.responSukses.code == 200) {
                    this.getData()
                }
            })
            await this.setOverlay(false)
        },
        tambah() {
            this.dialog = true;
            this.paramProp = 'tambah';
            this.val = {};
        },
        ubah(item) {
            this.val = item;
            this.dialog = true;
            this.paramProp = 'edit';
        },
        changePage(page) {
            this.page = page
            this.getData()
        },
        changeLimit(limit) {
            this.limit = limit
            this.page = 1
            this.getData()
        },
        searchFilter(data) {
            this.params = data
            this.getData()
        },
        onResetFilter() {
            this.params = []
            this.getData()
        },
        fontColorbyBG(bgColor) {
            let color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
            let r = parseInt(color.substring(0, 2), 16); // hexToR
            let g = parseInt(color.substring(2, 4), 16); // hexToG
            let b = parseInt(color.substring(4, 6), 16); // hexToB
            return ((r * 0.299) + (g * 0.587) + (b * 0.114)) <= 186;
        },
        truncate(str) {
            return (str.length > 40) ? str.slice(0, 39) + '...' : str;
        },
        generateEmbed(url) {
            let video_id = url.split('v=')[1]
            let ampersandPosition = video_id.indexOf('&')
            if (ampersandPosition != -1) {
                video_id = video_id.substring(0, ampersandPosition)
            }
            return "https://www.youtube.com/embed/" + video_id
        },
        isUrl(str) {
            return str.includes('https')
        }
    },
    async created() {
        let indexCategory = await this.filterData.findIndex(el => el.label == 'Kategori')
        this.filterData[indexCategory].item = await this.getTutorialCategoryOption()
        this.setFilter(this.filterData)
        this.getData()
        this.$store.dispatch('setPageTitle', `E-Learning `)
    },
    beforeDestroy() {
        this.clearDataTutorial()
    },
    watch: {
        option(val, old) {
            this.sortBy = val.sortBy[0]
            this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
            this.page = 1
            if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
                this.getData()
            }
        }
    }
}
</script>

<style>
tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .05);
}

.v-avatar .avatar {
    object-position: center;
    object-fit: cover;
}
</style>